import { makeStyles } from "@mui/styles";


const useExamScoreStyle = makeStyles(() => ({
  headingMain: {
    width: "100%",
    background: "#4565B7",
    "& .MuiTypography-h3": {
      color: "#FFF",
      textAlign: "center",
      fontSize: "1.3rem",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "2.625rem",
      textTransform: "capitalize",
    },
  },
}));

export default useExamScoreStyle;
